import dayjs from "dayjs";
import { toast } from "react-toastify";

import { nextCargoApi } from "../../baseApi";
import { Driver, ListDriverByCompany } from "./driver.types";

export const driverApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    getDriver: build.query<Driver, Pick<Driver, "id">, Driver>({
      query: ({ id }) => `/driver/${id}`,
      transformResponse: (response) => ({
        ...response,
        birthDate: dayjs(response.birthDate).format("DD/MM/YYYY")
      })
    }),
    listDriversByCompany: build.infiniteQuery<
      ListDriverByCompany,
      { id?: number; params?: App.Filters.Base<Driver> },
      App.Filters.Pagination<Driver, { companyId?: number }>,
      ListDriverByCompany
    >({
      infiniteQueryOptions: {
        initialPageParam: { page: 0, pageSize: 20, sortDirection: "asc", sortField: "name" },
        getNextPageParam: (lastPage, _, lastPageParam) => {
          const nextPage = lastPageParam.page + 1;
          const remainingPages = lastPage?.total - nextPage;

          if (remainingPages <= 0) {
            return undefined;
          }

          return {
            ...lastPageParam,
            page: nextPage
          };
        },
        getPreviousPageParam: (_, __, firstPageParam) => {
          const prevPage = firstPageParam.page - 1;
          if (prevPage < 0) return undefined;

          return {
            ...firstPageParam,
            page: prevPage
          };
        }
      },
      query: ({ queryArg: { params }, pageParam }) => ({
        url: "/driver",
        params: Object.assign({}, pageParam, params)
      }),
      transformResponse: (response) => {
        const transformedData = response.data.map((driver) => ({
          ...driver,
          birthDate: dayjs(driver.birthDate, "YYYY-MM-DD").format("DD/MM/YYYY")
        }));

        return {
          ...response,
          data: transformedData
        };
      },
      onQueryStarted: (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          pending: "Carregando motoristas...",
          error: "Erro ao carregar motoristas!"
        });
      }
    })
  })
});

driverApi.enhanceEndpoints({
  endpoints: {
    getDriver: {
      providesTags: (result, err, { id }) => [{ type: "Driver", id }]
    },
    listDriversByCompany: {
      providesTags: (response) =>
        response
          ? [...response.pages.flatMap((page) => page.data.map(({ id }) => ({ type: "Driver" as const, id }))), { type: "Driver", id: "LIST" }]
          : [{ type: "Driver", id: "LIST" }]
    }
  }
});
